// extracted by mini-css-extract-plugin
export default {"statusCard":"styles_statusCard__jO6VD","row":"styles_row__pmbEA","text_wrapper":"styles_text_wrapper__BlUfj","title":"styles_title__iFhig","description":"styles_description__W8lDd"};